var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('iframe',{staticStyle:{"width":"100%"},attrs:{"frameborder":"0","scrolling":"auto","id":"bi_iframe","srcdoc":_vm.htmlValue}})])}
var staticRenderFns = []

export { render, staticRenderFns }